import React from 'react';
import {Dropdown, DropdownProps, Icon, Menu} from 'semantic-ui-react';

interface TablePageProps {
    currentPage: number;
    totalPages: number;
    totalDocs?: number;
    limit: number;
    onPageChange: (page: number) => void;
    onLimitChange: (limit: number) => void;
    limitOptions?: number[];
}

export const TablePage: React.FC<TablePageProps> = ({
                                                        currentPage,
                                                        totalPages,
                                                        totalDocs,
                                                        limit,
                                                        onPageChange,
                                                        onLimitChange,
                                                        limitOptions = [10, 25, 50, 100],
                                                    }) => {
    const handlePageLimitChange = (e: any, data: DropdownProps) => {
        const { value } = data;
        if (typeof value === 'number') {
            onLimitChange(value);
            onPageChange(1);
        }
    };

    const handlePageChange = (e: any, data: DropdownProps) => {
        const { value } = data;
        if (typeof value === 'number') {
            onPageChange(value);
        }
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Menu.Item
                as="a"
                icon
                onClick={() => onPageChange(1)}
                disabled={currentPage === 1}
            >
                <Icon name="angle double left" />
            </Menu.Item>

            {currentPage > 1 && (
                <Menu.Item as="a" onClick={() => onPageChange(currentPage - 1)}>
                    {currentPage - 1}
                </Menu.Item>
            )}

            <Menu.Item style={{ background: 'lightgray' }}>
                {currentPage}
            </Menu.Item>

            {currentPage < totalPages && (
                <Menu.Item as="a" onClick={() => onPageChange(currentPage + 1)}>
                    {currentPage + 1}
                </Menu.Item>
            )}

            <Menu.Item
                as="a"
                icon
                onClick={() => onPageChange(totalPages)}
                disabled={currentPage === totalPages}
            >
                <Icon name="angle double right" />
            </Menu.Item>

            <Dropdown
                text={`${limit} на странице`}
                options={(limitOptions || [10, 25, 50, 100]).map(l => ({
                    key: l,
                    text: l.toString(),
                    value: l,
                }))}
                item
                upward
                onChange={handlePageLimitChange}
            />

            <Dropdown
                text={currentPage.toString()}
                scrolling
                options={Array.from({ length: totalPages }, (_, i) => ({
                    key: i + 1,
                    text: (i + 1).toString(),
                    value: i + 1,
                }))}
                item
                upward
                onChange={handlePageChange}
            />

            <Menu.Item>Страниц: {totalPages}</Menu.Item>
            <Menu.Item>Записей: {totalDocs ?? '-'}</Menu.Item>
        </div>
    );
};

export default TablePage;